import { surveyMode } from '@/v2/domains/Surveys/constants/constants';

import SurveyStepOptionsSingle from './SurveyStepOptionsSingle';
import SurveyStepOptionsMultiple from './SurveyStepOptionsMultiple';
import SurveyStepOptionsCta from './SurveyStepOptionsCta';

export default function SurveyStepOptions({
  mode,
  options,
  description,
  size = 'default',
  children,
}) {
  if (mode == surveyMode.CTA) {
    return (
      <SurveyStepOptionsCta options={options} description={description}>
        {children}
      </SurveyStepOptionsCta>
    );
  }

  if (mode == surveyMode.MULTIPLE) {
    return (
      <SurveyStepOptionsMultiple options={options} size={size}>
        {children}
      </SurveyStepOptionsMultiple>
    );
  }

  return (
    <SurveyStepOptionsSingle options={options} size={size}>
      {children}
    </SurveyStepOptionsSingle>
  );
}
